import { useEffect, useState } from 'react';
import { useCurrentUser } from '../../contexts/CurrentUserContext';
import { Lead } from '../leads/leads.type';

export const useNpLeadsPerMember = () => {
  const user = useCurrentUser();
  const [npLeads, setNpLeads] = useState<Record<string, Lead>>({});

  useEffect(() => {
    const leads: Record<string, Lead> = {};

    user?.state?.leads?.forEach(lead => {
      if (lead.leadType === 'NP' && lead.memberId) {
        leads[lead.memberId] = lead;
      }
    });

    setNpLeads(leads);
  }, [user?.state?.leads]);

  return npLeads;
};
